export enum Mime {
  'text/plain' = 'text/plain',
  'text/csv' = 'text/csv',
  'text/markdown' = 'text/markdown',
  'application/text' = 'application/text',
  'application/json' = 'application/json',
  'application/javascript' = 'application/javascript',
  'application/pdf' = 'application/pdf',
  'raw' = 'raw',
  'image/png' = 'image/png',
  'image/jpeg' = 'image/jpeg',
  'image/webp' = 'image/webp',
  'image/svg+xml' = 'image/svg+xml',
  'image/gif' = 'image/gif',
  'application/yaml' = 'application/yaml',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation' = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.ms-excel' = 'application/vnd.ms-excel',
  'application/vnd.ms-powerpoint' = 'application/vnd.ms-powerpoint',
  'application/msword' = 'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document' = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}
